<div class="para-container">
       <div *ngIf="params['keyMapping']['dataKey'] else single">
           <div  *ngFor="let myData of params.data[params['keyMapping']['dataKey']] let j = index; let last = last">
               <div  class="para-title wrap-text-cell">
                   {{myData[params['keyMapping']['title']]}}
               </div>
               <span class="wrap-text-cell" [ngStyle]="getStyles(this.limit,myData[params['keyMapping']['description']])" [ngClass]="{'unset-text-clip': isExpanded}">
<!--                {{myData[params['keyMapping']['description']]}}-->
                   <span [innerHTML]="myData[params['keyMapping']['description']]"></span>
                </span>
               <a *ngIf="last && this.showMoreButton && this.moreDetail" class="pointer" (click)="onClick()"> More details</a>
<!--               <a *ngIf="last && this.showMoreButton && this.readMore "  class="pointer" (click)="onClick()"> More details2 </a> &lt;!&ndash; for readmore &ndash;&gt;-->
           </div>
       </div>

        <ng-template #single>
            <div>
                <div  class="para-title wrap-text-cell">
                    {{params.data[params['keyMapping']['title']]}}
                </div>
                <span class="wrap-text-cell" [ngStyle]="getStyles(this.limit,params.data[params['keyMapping']['description']])" [ngClass]="{'unset-text-clip': isExpanded}">
<!--                {{params.data[params['keyMapping']['description']]}}-->
                    <span  [innerHTML]="params.data[params['keyMapping']['description']]"></span>
                </span>
                <a *ngIf="this.showMoreButton && this.readMore" class="pointer" (click)="onClick()"> More details</a>
                <a *ngIf="this.showMoreButton && this.moreDetail" class="pointer" (click)="onClick()"> More details</a>

            </div>
        </ng-template>
    <div class="wrap-text-cell" *ngIf="params.data[params['keyMapping']['reason']] as reasonCancelled;">{{reasonCancelled}}</div>
</div>

